import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'masking'
})
export class MaskingPipe implements PipeTransform {
  transform(value: string, type: 'email' | 'phone' | 'default'): string {
    switch (type) {
      case 'email':
        return this.validateEmail(value);
      case 'phone':
        return this.validatePhone(value);
      default:
        return value;
    }
  }

  private validateEmail(email: string): string {
    if (!email.includes('@')) {
      throw new Error('Geçersiz e-posta adresi. @ işareti içermelidir.');
    }
    return email;
  }

  private validatePhone(phone: string): string {
    if (!/^\d+$/.test(phone)) {
      throw new Error('Telefon numarası sadece rakamlardan oluşmalıdır.');
    }
    if (phone.length !== 10) {
      throw new Error('Telefon numarası 10 rakamdan oluşmalıdır.');
    }
    return phone;
  }
}
